export const countryListMap = {
  AI: 'Anguilla',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AU: 'Australia',
  AT: 'Austria',
  BS: 'Bahamas',
  BB: 'Barbados',
  BE: 'Belgium',
  BZ: 'Belize',
  BM: 'Bermuda',
  BO: 'Bolivia',
  BR: 'Brazil',
  BG: 'Bulgaria',
  KY: 'Cayman Islands',
  CL: 'Chile',
  CO: 'Colombia',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  SV: 'El Salvador',
  EE: 'Estonia',
  FO: 'Faroe Islands',
  FI: 'Finland',
  FR: 'France',
  GE: 'Georgia',
  DE: 'Germany',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GT: 'Guatemala',
  HU: 'Hungary',
  HN: 'Honduras',
  IS: 'Iceland',
  IL: 'Israel',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  LV: 'Latvia',
  LT: 'Lithuania',
  ME: 'Montenegro',
  NO: 'Norway',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  RO: 'Romania',
  RU: 'Russian Federation',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent and the Grenadines',
  SM: 'San Marino',
  RS: 'Serbia',
  SK: 'Slovakia',
  SI: 'Slovenia',
  ES: 'Spain',
  SE: 'Sweden',
  CH: 'Switzerland',
  TR: 'Turkey',
  UA: 'Ukraine',
  GB: 'United Kingdom of Great Britain and Northern Ireland',
  US: 'United States of America',
  UY: 'Uruguay',
  VU: 'Vanuatu',
  VE: 'Venezuela',
}

export const countryOptions = Object.entries(countryListMap).map(
  ([value, label]) => ({
    value,
    label,
  }),
)

export const VIDEO_VIEWS_MIN_RANGE = 0
export const VIDEO_VIEWS_MAX_RANGE = 100000000
export const VIDEO_VIEWS_SLIDER_STEP = 1000

export const TIKTOK_FOLLOWERS_MIN_RANGE = 0
export const TIKTOK_FOLLOWERS_MAX_RANGE = 100000000
export const TIKTOK_FOLLOWERS_SLIDER_STEP = 1000
